import { Component, type ReactNode } from 'react'
import * as Sentry from '@sentry/react'

/**
 * Catches an error thrown while drawing one screen, so the rest of the app (the rail, the other screens, the idle lock)
 * keeps working and staff see what happened instead of a black screen. Keyed by the path in App, so moving to another
 * screen starts clean. The error goes to Sentry with the path.
 */
export class ScreenBoundary extends Component<{ path: string; children: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null }
  static getDerivedStateFromError(error: Error) { return { error } }
  componentDidCatch(error: Error) { Sentry.captureException(error, { tags: { screen: this.props.path } }) }
  render() {
    if (!this.state.error) return this.props.children
    return (
      <div className="main">
        <div className="content"><div className="col">
          <div className="card" style={{ padding: 24, marginTop: 24 }}>
            <div style={{ fontSize: 20, fontWeight: 700 }}>This screen hit a problem</div>
            <div className="hint" style={{ padding: '8px 0 16px' }}>Nothing you recorded is lost. The error was sent to the team. Go back to Home and try again; if it keeps happening, tell Tim which screen it was.</div>
            <div className="hint" style={{ padding: '0 0 16px', fontFamily: 'ui-monospace, monospace', fontSize: 12 }}>{String(this.state.error.message).slice(0, 200)}</div>
            <button type="button" className="cta cta--center" onClick={() => { window.location.href = '/' }}>Back to Home</button>
          </div>
        </div></div>
      </div>
    )
  }
}
